var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15576 18.5166C0.762695 18.1348 0.773926 17.4834 1.15576 17.1016L8.34326 9.90283L1.15576 2.71533C0.773926 2.3335 0.773926 1.69336 1.15576 1.30029C1.5376 0.895996 2.2002 0.907227 2.58203 1.30029L9.76953 8.48779L16.957 1.30029C17.3389 0.907227 17.9902 0.907227 18.3833 1.30029C18.7764 1.68213 18.7651 2.3335 18.3833 2.71533L11.1958 9.90283L18.3833 17.1016C18.7651 17.4834 18.7651 18.1235 18.3833 18.5166C18.0015 18.9097 17.3389 18.8984 16.957 18.5166L9.76953 11.3291L2.58203 18.5166C2.2002 18.8984 1.54883 18.8984 1.15576 18.5166Z",
    fill: "#5A5976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c9f4296a73e15a9c0699adcf46e0c8f4.svg";
export { ForwardRef as ReactComponent };